// Module
var code = `<style>:host{display:inline-block;height:max-content}#text{display:inline-block;align-items:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;pointer-events:none}</style> <div id="text"></div>\``;
// Exports
export default code;